// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "actioncable" + ".bundle-" + "0f02de04fa9fe6015683" + ".digested.js";
};